/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { Close } from "@mui/icons-material";
import messages from "../../../../utils/messages";
import serviceFaturaSaldoChurn from "../../../../services/serviceFaturaSaldoChurn";
import { toast } from "react-toastify";

export interface IDialogProps {
    open: boolean;
    data: {
        open: boolean;
        id: string;
    };
    onClose?: any;
}

export default function DialogError({ open, data, onClose }: IDialogProps) {
    const [listErros, setListErros] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getErros = async (id: string) => {
        setIsLoading(true);
        const newValues = {
            faturaSaldoChurnID: id,
        };

        serviceFaturaSaldoChurn
            .getListaErros(newValues)
            .then((result) => {
                setListErros(result.data);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (open) {
            getErros(data.id);
        }
    }, [open]);

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <DialogTitle>
                Erros cobrança ID: {data.id}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box>
                    {isLoading ? (
                        <Box style={{ display: "flex", height: "40px", justifyContent: "center" }}>
                            <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                        </Box>
                    ) : ( 
                        <ul>
                            {(listErros &&
                                listErros.length > 0) ? 
                                    (listErros.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <Typography>
                                                    ID: {item.faturaSaldoChurnRetornoID} -{" "}
                                                    {item.dataHoraUltimaAtualizacao.slice(0, 10)} - {item.descricao}
                                                </Typography>
                                            </li>
                                        );
                                    })) 
                                : 
                                    "Nenhum erro encontrado"
                                }
                        </ul>
                    )}
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
